import { useCallback } from "react";
import { getTagOptions } from "../utils/tagStorage";
import { apiService } from "../service/apiClient.js";
import { apiUrl } from "../service/apiUrl.js";

export const useToolsApi = () => {
  const fetchToolsApi = useCallback(async () => {
    const res = await apiService.get(apiUrl.tools());
    return res.data || [];
  }, []);

  const fetchUnapprovedToolsApi = useCallback(async () => {
    const res = await apiService.get(apiUrl.unapprovedTools());
    return res.data || [];
  }, []);

  const fetchCategoriesApi = useCallback(async () => {
    const res = await apiService.get(apiUrl.categories());
    return res.data || [];
  }, []);

  const fetchTagOptionsApi = useCallback(async () => {
    const options = await getTagOptions();
    return options || [];
  }, []);

  const approveToolApi = useCallback(async (toolId) => {
    return apiService.put(apiUrl.approveTool(toolId), { status: "approved" });
  }, []);

  const rejectToolApi = useCallback(async (toolId) => {
    return apiService.put(apiUrl.rejectTool(toolId), { status: "rejected" });
  }, []);

  const createToolApi = useCallback(async (formData) => {
    return apiService.post(apiUrl.tools(), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }, []);

  const improveToolDescriptionApi = useCallback(async (description, productDocuments = []) => {
    const files = Array.isArray(productDocuments) ? productDocuments : [];

    if (files.length > 0) {
      const formData = new FormData();
      formData.append("description", description || "");
      files.forEach((file) => {
        formData.append("productDocuments", file);
      });

      const res = await apiService.post(apiUrl.improveToolDescription(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data || {};
    }

    const res = await apiService.post(apiUrl.improveToolDescription(), { description: description || "" });
    return res.data || {};
  }, []);

  const analyzeDashboardApi = useCallback(async (payload) => {
    const res = await apiService.post(apiUrl.dashboardAiAnalyze(), payload || {});
    return res.data || {};
  }, []);

  const dashboardChatApi = useCallback(async (payload) => {
    const res = await apiService.post(apiUrl.dashboardAiChat(), payload || {});
    return res.data || {};
  }, []);

  const dashboardDatabaseTablesApi = useCallback(async () => {
    const res = await apiService.get(apiUrl.dashboardAiDatabaseTables());
    return res.data || {};
  }, []);

  const dashboardDatabaseTableDataApi = useCallback(async (payload) => {
    const res = await apiService.post(apiUrl.dashboardAiDatabaseTableData(), payload || {});
    return res.data || {};
  }, []);

  return {
    fetchToolsApi,
    fetchUnapprovedToolsApi,
    fetchCategoriesApi,
    fetchTagOptionsApi,
    approveToolApi,
    rejectToolApi,
    createToolApi,
    improveToolDescriptionApi,
    analyzeDashboardApi,
    dashboardChatApi,
    dashboardDatabaseTablesApi,
    dashboardDatabaseTableDataApi,
  };
};

export default useToolsApi;
